const Overview = () => {
    return (
        <div id="overview" className="vision-card">

            <h3>OVERVIEW</h3>

            <p>
                Nav Jeevan Mission International School, situated at Nav Jeevan Nagar, 
                Medical College Road, Gulhariya, Gorakhpur (U.P.), is dedicated to providing 
                quality education and fostering the overall development of every student. 
                The school strives to create a nurturing and inspiring learning environment 
                where academic excellence, moral values, discipline, and character building 
                go hand in hand.

                The institution remains committed to its vision of nurturing young minds and 
                empowering them to achieve their full potential while contributing positively 
                to society. The academic session of the school normally extends from April to March.
            </p>
        </div>
    );
};

export default Overview;